import { Form, DatePicker, Tooltip } from "antd";
import K from "utilities/constants";
import { LabeledField } from "../labeledField/labeledField";

export const RecruitingStartDateField = ({
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const label = (
    <div>
      <Tooltip
        title="Starting point for the calculation of the time to paramenters"
        color={K.TooltipColor}
        placement="top"
      >
        <i className="icon-info-circle" />
      </Tooltip>
      &nbsp;Recruiting Start Date
    </div>
  );

  const renderField = () => (
    <DatePicker
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      format={K.DateFormat.DashUSFormat}
      className="datePickerModal"
      disabled={disabled}
      style={style}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        label={label}
        name="recruitingStartDate"
        rules={[
          {
            required: true,
            message: "Please select start date",
          },
        ]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label={label} required extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
